import { render, staticRenderFns } from "./claimApply.vue?vue&type=template&id=1b7a1aab&scoped=true"
import script from "./claimApply.vue?vue&type=script&lang=js"
export * from "./claimApply.vue?vue&type=script&lang=js"
import style0 from "./claimApply.vue?vue&type=style&index=0&id=1b7a1aab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7a1aab",
  null
  
)

export default component.exports